
const initialState = {
    isLoggedIn: false,
    user: null,
  };
  
  export const LOGIN = "LOGIN";
  export const LOGOUT = "LOGOUT";
  
  export const loginReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOGIN:
        return {
          ...state,
          isLoggedIn: true,
          user: action.payload,
        };
  
      case LOGOUT:
        return {
          ...state,
          isLoggedIn: false,
          user: null,
        };
  
      default:
        return state;
    }
  };
  

  export const login = (userData) => ({
    type: LOGIN,
    payload: userData,
  });
  
  export const logout = () => ({
    type: LOGOUT,
  });
  